
import { v4 as uuidv4 } from 'uuid';
import { Activity, Ambulance, Angry, Annoyed, Bath, BookCheck, Calendar1, CalendarClock, CalendarDays, ChartNoAxesCombined, CreditCard, CupSoda, Folder, Image, LayoutDashboard, Megaphone, MessageCircleMore, Newspaper, Notebook, NotebookPenIcon, Pill, PillBottle, ReceiptText, Salad, School, ShieldCheck, ShieldCheckIcon, TriangleAlert, User2, User2Icon, UserCog2, UserRoundCheck, UserRoundCog, UserRoundPlus, UserRoundX, UsersRound, Video } from 'lucide-react';


export const routes = [
    {
        key: uuidv4(),
        label: "Analytics",
        type: "group"
    },
    {
        key: uuidv4(),
        path: "/admin-dashboard",
        icons: <LayoutDashboard size={20} />,
        label: "Dashboard",
        type: "route",

    },
    {
        key: uuidv4(),
        path: "/report",
        icons: <ChartNoAxesCombined size={20} />,
        label: "Report",
        type: "route",
        permission: {
            module: "Reports",
            action: "view",
        },
    },

    {
        key: uuidv4(),
        label: "Management",
        type: "group",
        groups: ["Rooms", "Curriculum", "Children", "Attendance", "Activity", "Staff"]
    },

    {
        key: uuidv4(),
        path: "/room",
        icons: <School size={20} />,
        label: "Room",
        type: "route",
        permission: {
            module: "Rooms",
            action: "view",
        },
    },
    {
        key: uuidv4(),
        path: "/curriculum",
        icons: <NotebookPenIcon size={20} />,
        label: "Curriculum",
        type: "route",
        permission: {
            module: "Curriculum",
            action: "view",
        },
    },


    {
        key: uuidv4(),
        path: "/child",
        icons: <UsersRound size={20} />,
        label: "Children",
        permission: {
            module: "Children",
            action: "view",
        },
    },
    {
        key: uuidv4(),
        path: "/child-attendance",
        icons: <UsersRound size={20} />,
        label: "Attendance",
        permission: {
            module: "Attendance",
            action: "view",
        },
    },
    {
        key: uuidv4(),
        label: "Activity Planning",
        icons: <Activity size={20} />,
        permission: {
            module: "Activity",
            action: "view",
        },
        children: [
            {
                key: uuidv4(),
                path: "/photo-activity",
                icons: <Image size={20} />,
                label: "Photo",
            },
            {
                key: uuidv4(),
                path: "/video-activity",
                icons: <Video size={20} />,
                label: "Video",
            },
            {
                key: uuidv4(),
                path: "/learning-activity",
                icons: <BookCheck size={20} />,
                label: "Learning",
            },
            {
                key: uuidv4(),
                path: "/meal-activity",
                icons: <CupSoda size={20} />,
                label: "Meal",
            },

            {
                key: uuidv4(),
                path: "/nap-activity",
                icons: <Annoyed size={20} />,
                label: "Nap",
            },
            {
                key: uuidv4(),
                path: "/bathroom-activity",
                icons: <Bath size={20} />,
                label: "Bathroom",
            },
            {
                key: uuidv4(),
                path: "/bottle-activity",
                icons: <PillBottle size={20} />,
                label: "Bottle",
            },
            {
                key: uuidv4(),
                path: "/mood-activity",
                icons: <Angry size={20} />,
                label: "Mood",
            },
            {
                key: uuidv4(),
                path: "/meds-activity",
                icons: <Pill size={20} />,
                label: "Meds",
            },
            {
                key: uuidv4(),
                path: "/note-activity",
                icons: <Notebook size={20} />,
                label: "Note",
            },

        ],
    },
    {
        key: uuidv4(),
        label: "Staff Management",
        icons: <UserRoundCog size={20} />,

        permission: {
            module: "Staff",
            action: "view",
        },
        children: [
            {
                key: uuidv4(),
                path: "/staff",
                icons: <UserCog2 size={20} />,
                label: "Staff  ",
            },
            {
                key: uuidv4(),
                path: "/staff-attendence",
                icons: <CalendarClock size={20} />,
                label: "Attendence  ",
            },
            {
                key: uuidv4(),
                path: "/staff-shift",
                icons: <Calendar1 size={20} />,
                label: "Shift  ",
            },
            {
                key: uuidv4(),
                path: "/staff-Times-Stamps",
                icons: <Calendar1 size={20} />,
                label: "Shift Times Stamps ",
            },
            {
                key: uuidv4(),
                path: "/staff-role",
                icons: <UserRoundPlus size={20} />,
                label: "Assign Role ",
            },

        ],
    },

    {
        key: uuidv4(),
        label: "Operations",
        type: "group",
        groups: ["Meals", "Leave Request", "Documents", "Newsletter", "Message", "Event", "Incident And Behavior"]
    },

    {
        key: uuidv4(),
        path: "/meals-plan-room",
        icons: <Salad size={20} />,
        label: "Meals Plan",
        type: "route",
        permission: {
            module: "Meals",
            action: "view",
        },
    },

    {
        key: uuidv4(),
        path: "/leave-request",
        icons: <UserRoundCheck size={20} />,
        label: "Leave Request ",
        type: "route",
        permission: {
            module: "Leave Request",
            action: "view",
        },
    },

    {
        key: uuidv4(),
        path: "/documents",
        icons: <Folder size={20} />,
        label: "Documents ",
        type: "route",
        permission: {
            module: "Documents",
            action: "view",
        },
    },

    {
        key: uuidv4(),
        path: "/news-letter",
        icons: <Megaphone size={20} />,
        label: "News Letter ",
        type: "route",
        permission: {
            module: "Newsletter",
            action: "view",
        },
    },

    {
        key: uuidv4(),
        path: "/message",
        icons: <MessageCircleMore size={20} />,
        label: "Message",
        type: "route",
        permission: {
            module: "Message",
            action: "view",
        },
    },
    {
        key: uuidv4(),
        path: "/event",
        icons: <CalendarDays size={20} />,
        label: "Event",
        permission: {
            module: "Event",
            action: "view",
        },
    },
    {
        key: uuidv4(),
        path: "/incident-behavior",
        icons: <TriangleAlert size={20} />,
        label: "Incident Behavior",
        permission: {
            module: "Incident And Behavior",
            action: "view",
        },
    },
    {
        key: uuidv4(),
        path: "/assign-kiosk",
        icons: <ShieldCheck size={20} />,
        label: "Sign In Kiosk",
        type: "route",
    },

    {
        key: uuidv4(),
        label: "Finance",
        type: "group",
        groups: ["Billing", "HR(Payroll)"]
    },

    {
        key: uuidv4(),
        path: "/bill",
        icons: <ReceiptText size={20} />,
        label: "Billing ",
        type: "route",
        permission: {
            module: "Billing",
            action: "view",
        },
    },
    {
        key: uuidv4(),
        path: "/hr-payroll",
        icons: <CreditCard size={20} />,
        label: "HR Payroll",
        type: "route",
        permission: {
            module: "HR(Payroll)",
            action: "view",
        },
    },


]

export const staffRoutes = [
    {
        key: uuidv4(),
        label: "Analytics",
        type: "group"
    },
    {
        key: uuidv4(),
        path: "/staff/dashboard",
        icons: <LayoutDashboard size={20} />,
        label: "Dashboard",
        type: "route",
        public: true,

    },
    {
        key: uuidv4(),
        path: "/staff/report",
        icons: <ChartNoAxesCombined size={20} />,
        label: "Report",
        type: "route",
        permission: {
            module: "Reports",
            action: "view",
        },
    },

    {
        key: uuidv4(),
        label: "Management",
        type: "group",
        groups:
            ["Rooms", "Curriculum", "Children", "Attendance", "Activity", "Staff"]
    },

    {
        key: uuidv4(),
        path: "/staff/room",
        icons: <School size={20} />,
        label: "Room",
        type: "route",
        permission: {
            module: "Rooms",
            action: "view",
        },
    },
    {
        key: uuidv4(),
        path: "/staff/curriculum",
        icons: <NotebookPenIcon size={20} />,
        label: "Curriculum",
        type: "route",
        permission: {
            module: "Curriculum",
            action: "view",
        },
    },


    {
        key: uuidv4(),
        path: "/staff/child",
        icons: <UsersRound size={20} />,
        label: "Children",
        permission: {
            module: "Children",
            action: "view",
        },
    },
    {
        key: uuidv4(),
        path: "/staff/child-attendance",
        icons: <UserRoundCheck size={20} />,
        label: "Attendance",
        permission: {
            module: "Attendance",
            action: "view",
        },
    },
    {
        key: uuidv4(),
        label: "Activity Planning",
        icons: <Activity size={20} />,
        permission: {
            module: "Activity",
            action: "view",
        },
        children: [
            {
                key: uuidv4(),
                path: "/staff/photo-activity",
                icons: <Image size={20} />,
                label: "Photo",
            },
            {
                key: uuidv4(),
                path: "/staff/video-activity",
                icons: <Video size={20} />,
                label: "Video",
            },
            {
                key: uuidv4(),
                path: "/staff/learning-activity",
                icons: <BookCheck size={20} />,
                label: "Learning",
            },
            {
                key: uuidv4(),
                path: "/staff/meal-activity",
                icons: <CupSoda size={20} />,
                label: "Meal",
            },

            {
                key: uuidv4(),
                path: "/staff/nap-activity",
                icons: <Annoyed size={20} />,
                label: "Nap",
            },
            {
                key: uuidv4(),
                path: "/staff/bathroom-activity",
                icons: <Bath size={20} />,
                label: "Bathroom",
            },
            {
                key: uuidv4(),
                path: "/staff/bottle-activity",
                icons: <PillBottle size={20} />,
                label: "Bottle",
            },
            {
                key: uuidv4(),
                path: "/staff/mood-activity",
                icons: <Angry size={20} />,
                label: "Mood",
            },
            {
                key: uuidv4(),
                path: "/staff/meds-activity",
                icons: <Pill size={20} />,
                label: "Meds",
            },
            {
                key: uuidv4(),
                path: "/staff/note-activity",
                icons: <Notebook size={20} />,
                label: "Note",
            },

        ],
    },
    {
        key: uuidv4(),
        label: "Staff Management",
        icons: <UserRoundCog size={20} />,
        permission: {
            module: "Staff",
            action: "view",
        },
        children: [
            {
                key: uuidv4(),
                path: "/staff/staff",
                icons: <UserCog2 size={20} />,
                label: "Staff  ",
            },
            {
                key: uuidv4(),
                path: "/staff/staff-attendence",
                icons: <CalendarClock size={20} />,
                label: "Attendence",
            },
            {
                key: uuidv4(),
                path: "/staff/staff-shift",
                icons: <Calendar1 size={20} />,
                label: "Shift  ",
            },
            {
                key: uuidv4(),
                path: "/staff/staff-Times-Stamps",
                icons: <Calendar1 size={20} />,
                label: "Shift Times Stamps ",
            },
            {
                key: uuidv4(),
                path: "/staff/staff-role",
                icons: <UserRoundPlus size={20} />,
                label: "Assign Role ",
            },

        ],
    },

    {
        key: uuidv4(),
        label: "Operations",
        type: "group",
        groups:
            ["Meals", "Leave Request", "Documents", "Newsletter", "Message", "Event", "Incident And Behavior"]
    },

    {
        key: uuidv4(),
        path: "/staff/meals-plan-room",
        icons: <Salad size={20} />,
        label: "Meals Plan",
        type: "route",
        permission: {
            module: "Meals",
            action: "view",
        },
    },

    {
        key: uuidv4(),
        path: "/staff/leave-request",
        icons: <UserRoundCheck size={20} />,
        label: "Leave Request ",
        type: "route",
        permission: {
            module: "Leave Request",
            action: "view",
        },
    },

    {
        key: uuidv4(),
        path: "/staff/documents",
        icons: <Folder size={20} />,
        label: "Documents ",
        type: "route",
        permission: {
            module: "Documents",
            action: "view",
        },
    },

    {
        key: uuidv4(),
        path: "/staff/news-letter",
        icons: <Megaphone size={20} />,
        label: "News Letter ",
        type: "route",
        permission: {
            module: "Newsletter",
            action: "view",
        },
    },

    {
        key: uuidv4(),
        path: "/staff/message",
        icons: <MessageCircleMore size={20} />,
        label: "Message",
        type: "route",
        permission: {
            module: "Message",
            action: "view",
        },
    },
    {
        key: uuidv4(),
        path: "/staff/event",
        icons: <CalendarDays size={20} />,
        label: "Event",
        permission: {
            module: "Event",
            action: "view",
        },
    },
    {
        key: uuidv4(),
        path: "/staff/incident-behavior",
        icons: <TriangleAlert size={20} />,
        label: "Incident Behavior",
        permission: {
            module: "Incident And Behavior",
            action: "view",
        },
    },



    {
        key: uuidv4(),
        label: "Finance",
        type: "group",
        groups: ["Billing", "HR(Payroll)"]
    },

    {
        key: uuidv4(),
        path: "/staff/bill",
        icons: <ReceiptText size={20} />,
        label: "Billing",
        type: "route",
        permission: {
            module: "Billing",
            action: "view",
        },
    },
    {
        key: uuidv4(),
        path: "/staff/hr-payroll",
        icons: <CreditCard size={20} />,
        label: "HR Payroll",
        type: "route",
        permission: {
            module: "HR(Payroll)",
            action: "view",
        },
    },

    {
        key: uuidv4(),
        label: "Kiosk Management",
        type: "group",
        groups: ["Sign In Kiosk"]
    },

    {
        key: uuidv4(),
        path: "/signin-kiosk",
        icons: <ShieldCheck size={20} />,
        label: "Sign In Kiosk",
        type: "route",
        permission: {
            module: "Sign In Kiosk",
            action: "view",
        },
    },

]

export const parentRoutes = [
    {
        key: uuidv4(),
        label: "Analytics",
        type: "group"
    },
    {
        key: uuidv4(),
        path: "/parent/dashboard",
        icons: <LayoutDashboard size={20} />,
        label: "Dashboard",
        type: "route",

    },

    {
        key: uuidv4(),
        label: "Management",
        type: "group"
    },

    {
        key: uuidv4(),
        path: "/parent/curriculum",
        icons: <NotebookPenIcon size={20} />,
        label: "Curriculum",
        type: "route",

    },
    {
        key: uuidv4(),
        path: "/parent/attendance",
        icons: <UserRoundCheck size={20} />,
        label: "Attendance",
        type: "route",

    },
    {
        key: uuidv4(),
        label: "Activity Planning",
        icons: <Activity size={20} />,

        children: [
            {
                key: uuidv4(),
                path: "/parent/photo-activity",
                icons: <Image size={20} />,
                label: "Photo",
            },
            {
                key: uuidv4(),
                path: "/parent/video-activity",
                icons: <Video size={20} />,
                label: "Video",
            },
            {
                key: uuidv4(),
                path: "/parent/learning-activity",
                icons: <BookCheck size={20} />,
                label: "Learning",
            },
            {
                key: uuidv4(),
                path: "/parent/meal-activity",
                icons: <CupSoda size={20} />,
                label: "Meal",
            },

            {
                key: uuidv4(),
                path: "/parent/nap-activity",
                icons: <Annoyed size={20} />,
                label: "Nap",
            },
            {
                key: uuidv4(),
                path: "/parent/bathroom-activity",
                icons: <Bath size={20} />,
                label: "Bathroom",
            },
            {
                key: uuidv4(),
                path: "/parent/bottle-activity",
                icons: <PillBottle size={20} />,
                label: "Bottle",
            },
            {
                key: uuidv4(),
                path: "/parent/mood-activity",
                icons: <Angry size={20} />,
                label: "Mood",
            },
            {
                key: uuidv4(),
                path: "/parent/meds-activity",
                icons: <Pill size={20} />,
                label: "Meds",
            },
            {
                key: uuidv4(),
                path: "/parent/note-activity",
                icons: <Notebook size={20} />,
                label: "Note",
            },

        ],
    },

    {
        key: uuidv4(),
        label: "Child Safety",
        icons: <ShieldCheckIcon size={20} />,
        children: [
            {
                key: uuidv4(),
                path: "/parent/emergency-contact",
                icons: <Ambulance size={20} />,
                label: "Emergency Contact",
            },
            {
                key: uuidv4(),
                path: "/parent/authorised-pickup",
                icons: <UserRoundCheck size={20} />,
                label: "Authorised Pickup",
            },
            {
                key: uuidv4(),
                path: "/parent/unauthorised-pickup",
                icons: <UserRoundX size={20} />,
                label: "Unauthorised Pickup",
            },
        ],
    },


    {
        key: uuidv4(),
        label: "Operations",
        type: "group"
    },

    {
        key: uuidv4(),
        path: "/parent/meals-plan",
        icons: <Salad size={20} />,
        label: "Meals Plan",
        type: "route",

    },

    {
        key: uuidv4(),
        path: "/parent/news-letter",
        icons: <Megaphone size={20} />,
        label: "News Letter ",
        type: "route",

    },
    {
        key: uuidv4(),
        path: "/parent/message",
        icons: <MessageCircleMore size={20} />,
        label: "Message",
        type: "route",

    },
    {
        key: uuidv4(),
        path: "/parent/event",
        icons: <CalendarDays size={20} />,
        label: "Event",

    },
    {
        key: uuidv4(),
        path: "/parent/incident-behavior",
        icons: <TriangleAlert size={20} />,
        label: "Incident Behavior",

    },



    {
        key: uuidv4(),
        label: "Finance",
        type: "group"
    },

    {
        key: uuidv4(),
        path: "/parent/bill",
        icons: <ReceiptText size={20} />,
        label: "Billing ",
        type: "route",

    },
]